import type {
  CaseSizeRuleUpdateRequestType,
  CaseSizeRuleUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCaseSizeRuleUpdate = (caseSizeRuleId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CaseSizeRuleUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `case-size-rule/${caseSizeRuleId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as CaseSizeRuleUpdateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.CaseSizeRules],
      });
    },
  });
};
